<template>
  <div>
    <table>
      <tr>
        <td>
          <table>
            <tr>
              <td>
                <div style="float: left; padding-left: 25px">
                  <h1>{{ translateWords.RackList }}</h1>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <template>
                  <table style="width: 60%">
                    <tr>
                     <td>  <div style="float: left; padding-left: 25px">
                        <el-select
                          v-model="gsfj"
                          :placeholder="translateWords.RoomBelongTo"
                        >
                          <el-option
                            v-for="item in gsfjoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option
                        ></el-select>
                        </div>
                      </td>
                      <td><div style="float: left; padding-left: 25px">
                        <el-select
                          v-model="qy"
                          :placeholder="translateWords.SelectArea"
                          ><el-option
                            v-for="item in qyoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option
                        ></el-select></div>
                      </td>
                      <td><div style="float: left; padding-left: 25px">
                        <el-input
                          v-model="hjh"
                          :placeholder="translateWords.RackNumber"
                        ></el-input></div>
                      </td>
                      <td><div style="float: left; padding-left: 25px">
                        <el-button type="primary" @click="query" v-if="PermissonList.Search.value">
                          {{ translateWords.Query }}</el-button
                        ></div>
                      </td>
                      <td>
                        <div style="float: left; padding-left: 20px">
                          <el-button type="primary" @click="Openaddrack" v-if="PermissonList.Add.value">{{
                            translateWords.AddRack
                          }}</el-button>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <div>
                    <el-table :data="tableData" style="width: 100%">
                      <el-table-column
                       
                        width="100"
                        prop="Id"
                        label="Id"
                      >
                      </el-table-column>
                      <el-table-column
                        v-if="false"
                        prop="PositionId"
                        :label="translateWords.LocalId"
                      >
                      </el-table-column>

                         <el-table-column
                        v-if="false"
                        prop="IsUseRackCode"
                        :label="translateWords.LocalId"
                      >
                      </el-table-column>

                          <el-table-column
                        v-if="false"
                        prop="IsUseRackLayerCode"
                        :label="translateWords.LocalId"
                      >
                      </el-table-column>
                      <el-table-column
                        width="600px"
                        prop="PositionId"
                        :label="translateWords.Local"
                      >
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.PositionName"
                            filterable
                            style="width: 550px"
                            disabled
                            @change="
                              selectposition(scope.row.PositionName, scope.row)
                            "
                          >
                            <el-option
                              v-for="item in rowPositionIdoptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="RackNo"
                        :label="translateWords.RackNumber"
                        width="200"
                      >
                        <template slot-scope="scope">
                          <el-input
                            class="RackNo"
                            v-model="scope.row.RackNo"
                            disabled
                          ></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="100"
                        prop="LayerNo"
                        :label="translateWords.RackLayer"
                      >
                        <template slot-scope="scope">
                          <el-input
                            class="LayerNo"
                            v-model.number="scope.row.LayerNo"
                            disabled
                          ></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="100"
                        prop="IsUseRack"
                        :label="translateWords.IsUseRack"
                      >
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.IsUseRack"
                            filterable
                            disabled
                          >
                            <el-option
                              v-for="item in rowIsUseRackoptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>

                      <el-table-column
                        width="100"
                        prop="IsUseRack"
                        :label="translateWords.IsUseRackLayer"
                      >
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.IsUseRackLayer"
                            filterable
                            disabled
                          >
                            <el-option
                              v-for="item in rowIsUseRackLayeroptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                        width="200"
                        prop="Code"
                        :label="translateWords.RackCode"
                      >
                      </el-table-column>

                      <el-table-column
                        prop="SubCode"
                        :label="translateWords.SubCode"
                        width="200"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="Remark"
                        :label="translateWords.Remark"
                        width="200"
                      >
                        <template slot-scope="scope">
                          <el-input
                            class="Remark"
                            v-model="scope.row.Remark"
                            disabled
                          ></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="translateWords.Opearate"
                        width="200"
                      >
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            type="primary" v-if="PermissonList.Update.value"
                            @click="handleEdit(scope.$index, scope.row)"
                            >{{ translateWords.Edit }}</el-button
                          >
                          <el-button
                            size="mini"
                            type="danger" v-if="PermissonList.Delete.value"
                            @click="handleDelete(scope.$index, scope.row)"
                            >{{ translateWords.Delete }}</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="1"
                  :page-sizes="[10, 20, 30]"
                  :page-size="10"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </td>
            </tr>
            <tr>
              <td></td>
            </tr>
          </table>
        </td>
        <td style="width: 10%"></td>
      </tr>
      <tr>
        <td>
          <el-dialog
            :visible.sync="dialogVisible"
            width="50%"
            :show-close="true"
          >
            <div>
              <AddRack
                ref="AddRack"
                :PositionIdoptions="gsfjoptions"
                @closedialog="closedialog"
              ></AddRack>
            </div>
            <span slot="footer" class="dialog-footer">
              <!-- <el-button @click="closedialog();">关闭页面</el-button> -->
            </span>
          </el-dialog>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
// import AddRackLayer from '@/components/AddRackLayer'
import AddRack from "@/components/AddRack";
import { importScript } from "../util/importScript";
import global from "./Global";
export default {
  name: "Rack",
  components: {
    //  AddRackLayer,
    AddRack,
  },
  data() {
    return {
      translateWords: {
        RackList: "货架列表",
        RoomBelongTo: "请选择位置",
        SelectArea: "请选择区域",
        RackNumber: "货架号",
        Query: "查询",
        AddhuRack: "新增货架",
        LocalId: "位置Id",
        Local: "位置",
        RackLayer: "货架层",
        IsUseRack: "启用货架",
        IsUseRackLayer: "启用货架层",
        RackCode: "货架主码",
        SubCode: "货架层子码",
        Remark: "备注",
        Opearate: "操作",
        Save: "保存",
        Edit: "编辑",
        Delete: "删除",
        //下面是方法中的词条
        loadFail: "初始化下拉加载失败",
        delSuccess: "删除成功",
        selectOneLocal: "请选择一个位置",
        selectLayer: "请选择输入层数",
        selectRackStatus: "请选择货架状态",
        selectLayerStatu: "请选择货架层状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        AddRack:"新增货架"
      },
      total: 0,
      currPage: 1,
      pageSize: 10,
      isQuery: false,
      gsfjoptions: [],
      qyoptions: [],
      hjhoptions: [],
      tableData: [],
      dialogVisible: false,
      gsfj: "",
      qy: "",
      hjh: "",
      Id: 0,
      IsEdit: false,
      uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang,
      rowIsUseRackoptions: [],
      rowIsUseRackLayeroptions: [],
      rowRackLayerIdoptions: [],
      rowjson: ""
     
    };
  },
  created: function () {
    this.PermissonList=  global.methods.GetOaRight(this.$store.state.RackModuleCode,this.$store.state.RackPermissonList,this.$route.query.token,this.$http,this.oarighturl)
    this.GetDropInit();
    this.getinitstatus();
    this.getData(1, this.pageSize);
  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.translateWord();
    });
  },
  methods: {
    translateWord() {
      var that = this;
      if (window.jsT) {
        this.translateWords = {
          RackList: window.jsT.T(that.translateWords.RackList),
          RoomBelongTo: window.jsT.T(that.translateWords.RoomBelongTo),
          SelectArea: window.jsT.T(that.translateWords.SelectArea),
          RackNumber: window.jsT.T(that.translateWords.RackNumber),
          Query: window.jsT.T(that.translateWords.Query),
          AddRack: window.jsT.T(that.translateWords.AddRack),
          LocalId: window.jsT.T(that.translateWords.LocalId),
          Local: window.jsT.T(that.translateWords.Local),
          RackLayer: window.jsT.T(that.translateWords.RackLayer),
          IsUseRack: window.jsT.T(that.translateWords.IsUseRack),
          IsUseRackLayer: window.jsT.T(that.translateWords.IsUseRackLayer),
          RackCode: window.jsT.T(that.translateWords.RackCode),
          SubCode: window.jsT.T(that.translateWords.SubCode),
          Remark: window.jsT.T(that.translateWords.Remark),
          Opearate: window.jsT.T(that.translateWords.Opearate),
          Save: window.jsT.T(that.translateWords.Save),
          Delete: window.jsT.T(that.translateWords.Delete),
          Edit: window.jsT.T(that.translateWords.Edit),
          loadFail: window.jsT.T(that.translateWords.loadFail),
          delSuccess: window.jsT.T(that.translateWords.delSuccess),
          selectOneLocal: window.jsT.T(that.translateWords.selectOneLocal),
          selectLayer: window.jsT.T(that.translateWords.selectLayer),
          selectRackStatus: window.jsT.T(that.translateWords.selectRackStatus),
          selectLayerStatu: window.jsT.T(that.translateWords.selectLayerStatu),
          saveSuccess: window.jsT.T(that.translateWords.saveSuccess),
          saveFail: window.jsT.T(that.translateWords.saveFail),
        };
        console.log(this.translateWords);
      } else {
        console.log("翻译组件加载失败");
      }
    },
     
    Openaddrack() {
      this.$nextTick(function () {
        this.$refs.AddRack.init();
      });
      this.dialogVisible = true;
    },
    getinitstatus() {
      var params = new URLSearchParams();
      params.append("cmd", "GetStatus");
      params.append("lang", this.lang);
      this.$http.post(this.actionurl, params).then((res) => {
        this.rowIsUseRackoptions = res.data.Data;
        this.rowIsUseRackLayeroptions = res.data.Data;
      });
    },
    closedialog() {
      this.dialogVisible = false;
      // location.reload();
      this.getData(1, 10);
    },
    GetDropInit() {
      var that = this;
      var params = new URLSearchParams();
       params.append("uid", this.uid);
      params.append("cmd", "InitDrop");
      params.append("lang", this.lang);
      this.$http.post(this.actionurl, params).then((res) => {
        if (res.data.Message == "") {
          this.gsfjoptions = res.data.Data.LoadDropPosition;
          this.qyoptions = res.data.Data.LoadDropRegion;
          //this.hjhoptions=res.data.Data.LoadDropRackNo;
          this.rowPositionIdoptions = res.data.Data.LoadDropPosition;
          this.rowRackLayerIdoptions = res.data.Data.LoadDropLayer;
        } else {
          alert(that.translateWords.loadFail + "," + res.data.Message);
          // this.$message({
          //   message: res.data.Message,
          //   type: "error"
          // });
        }
      });
    },
    query() {
      this.isQuery = true;
      this.getData(1, 10);
    },
    getData(index, size) {
      var params = new URLSearchParams();
      params.append("pageIndex", index);
      params.append("pageSize", size);
      params.append("lang", this.lang);
       params.append("uid", this.uid);
      params.append("cmd", "LoadSampleRack");
      if (this.isQuery) {
        params.append("gsfj", this.gsfj);
        params.append("qy", this.qy);
        params.append("hjh", this.hjh);
      }
      this.$http.post(this.actionurl, params).then((res) => {
        this.tableData = res.data.Data.list;
        this.total = res.data.Data.total;
      });
    },
    selectposition(val, row) {
      row.PositionId = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currPage = 1;
      this.getData(this.currPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.getData(this.currPage, this.pageSize);
    },
    handleDelete: function (index, row) {
      var that = this;
      var params = new URLSearchParams();
      params.append("id", row.Id);
      params.append("uid", this.uid);
      params.append("cmd", "DeleteRack");
      this.$http.post(this.actionurl, params).then((res) => {
        if (res.data.Message == "") {
          //  this.$message({
          //         message: '删除成功',
          //         type: 'success'
          //       });
          alert(that.translateWords.delSuccess);
          this.getData(1, this.pageSize);
        } else {
          // this.$message({
          //   message: res.data.Message,
          //   type: "error"
          // });
          alert(res.data.Message);
        }
      });
    },
    handleEdit: function (index, row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.AddRack.setvalue(JSON.stringify(row));
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Rack.vue